import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const TimeRenderer = (params) => {
  const { value, showTime = true } = params;
  if (!value) return "";

  // Convert UTC string to local time
  const localTime = dayjs.utc(value).local();

  if (!localTime.isValid()) return value;

  const formattedDate = localTime.format("MM/DD/YYYY");
  const formattedTime = localTime.format("hh:mm:ss A");

  return showTime ? `${formattedDate} ${formattedTime}` : formattedDate;
};